import { OperatorLeadershipScorecard } from "@/components/non_registrant/operator-leadership-scorecard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/overview_/leadership")({
  component: OperatorLeadershipScorecard,
});
